import * as React from 'react';

// Components
import CoursePlaylist from 'Screens/CoursePlaylist/Student/Containers/CoursePlaylist';
import CourseInfo from 'Screens/CourseInfo/Student/CourseInfo';
import Forum from 'Screens/Forum/Student/Forum';
import Progress from 'Screens/Progress/Student/Progress';
import PublicProgress from 'Screens/PublicProgress/Student/PublicProgress';
import ChatroomForm from 'Screens/ChatroomForm/Student/ChatroomForm';
import Rga from 'Screens/Rga/Student/Rga';
import AssignmentsGroup from 'Screens/AssignmentsGroup/Student/AssignmentsGroup';
import TimedQuiz from 'Screens/TimedQuiz/Student/TimedQuiz';
import Marks from 'Screens/Marks/Student/Marks';
import Schedule from 'Screens/Schedule/Student/Schedule';
import EmailStudentArchive from 'Screens/EmailStudentArchive/Student/EmailStudentArchive';
import Page from 'Screens/Page/Student/Page';

// Assets
import '../Assets/CourseBodyStudentPage.sass';

interface IProps {
    courseid: any;
    forumid: any;
    id: any;
    groupid: any;
}

export default class CourseContent extends React.Component<IProps, {}> {
    private getIntendedComponent(component_id) {
        switch (component_id) {
            case 'content':
                return <CoursePlaylist courseid={this.props.courseid} groupid={this.props.groupid}/>;
            case 'information':
                return <CourseInfo course={this.props.courseid}/>;
            case 'discussion-forum':
                return <Forum id={this.props.forumid}/>;
            case 'progress':
                return <Progress course={this.props.courseid}/>;
            case 'score-card':
                return <PublicProgress course={this.props.courseid}/>;
            case 'chat':
                return <ChatroomForm teacher={false} course={this.props.courseid}/>;
            case 'report-grading':
                return <Rga courseid={this.props.courseid}/>;
            case 'assignments':
                return <AssignmentsGroup
                    key={'0'}
                    group={{'id':'0','title':'Programming Assignments',}}
                    courseid={this.props.courseid}
                    index={0}
                />;
            case 'timed-quiz':
                return <TimedQuiz courseid={this.props.courseid}/>;
            case 'marks':
                return <Marks teacher={false} courseid={this.props.courseid}/>;
            case 'schedule':
                return <Schedule course={this.props.courseid}/>;
            case 'email':
                return <EmailStudentArchive courseid={this.props.courseid}/>;
            default:
                if (this.props.id > 0)
                    return <Page id={this.props.id}/>;
                window.history.replaceState('', '', `/courseware/course/${this.props.courseid}/content/`);
                return <CoursePlaylist groupid={this.props.groupid} courseid={this.props.courseid}/>;
        }
    }

    public render() {
        return <div>{this.getIntendedComponent(this.props.id)}</div>;
    }
};
